import { Component, HostListener } from '@angular/core';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
  styleUrl: './home-two.component.css'
})
export class HomeTwoComponent {
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  //Header End

  //Services
  services = [
    {
      icon: 'bi-star',
      title: 'Real time analytics',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
    },
    {
      icon: 'bi-brush',
      title: 'Google advertising',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
    },
    {
      icon: 'bi-camera',
      title: 'Pixel perfect design',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
    },
  ];

  //Funfacts
  funFacts =[
    {
      number: 2530,
      desc: "Working Hours",
      displayedNumber: 0
    },
    {
      number: 1000,
      desc: "Photo Capture",
      displayedNumber: 0
    },
    {
      number: 500,
      desc: "Project Completed",
      displayedNumber: 0
    },
    {
      number: 300,
      desc: "Telephonic Talk",
      displayedNumber: 0
    }
  ]

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    this.funFacts.forEach(fact => {
      this.animateCounter(fact);
    });
  }

  animateCounter(fact: any): void {
    const duration = 4000; 
    const intervalTime = 50; 
    const increment = fact.number / (duration / intervalTime);

    const interval = setInterval(() => {
      fact.displayedNumber += increment;
      if (fact.displayedNumber >= fact.number) {
        fact.displayedNumber = fact.number;
        clearInterval(interval); 
      }
    }, intervalTime);
  }

  // Skills
  skills = [
    { name: 'Innovative solutions', level: 94 },
    { name: 'Marketing strategy', level: 88 },
    { name: 'Social Marketing', level: 92 },
    { name: 'Content Creation', level: 70 }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  //Brand Logos
  brands = [
    { image: 'assets/images/brands/brand-1.png', alt: 'brand-1' },
    { image: 'assets/images/brands/brand-2.png', alt: 'brand-2' },
    { image: 'assets/images/brands/brand-3.png', alt: 'brand-3' },
    { image: 'assets/images/brands/brand-4.png', alt: 'brand-4' },
    { image: 'assets/images/brands/brand-5.png', alt: 'brand-5' },
    { image: 'assets/images/brands/brand-6.png', alt: 'brand-6' }
  ];

  brandCarouselOptions = {
    loop: true,
    margin: 50,
    autoplay: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 3 },
      992: { items: 5 },
      1200: { items: 5 }
    }
  };

  //Works
  portfolioWorks =[
    {
      img:'assets/images/portfolio/gallery-11.jpg',
      title:'Digital Food',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-12.jpg',
      title:'Poster',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-13.jpg',
      title:'Blue Berry',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-14.jpg',
      title:'Death Proof',
      category:'UI/UX Design',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-15.jpg',
      title:'Ten Branding',
      category:'Branding, UX Design',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-16.jpg',
      title:'Old Camera',
      category:'UI/UX Design',
      link: '/portfolio-detail'
    }
  ];

  socialIcons = [
    { name: 'facebook', icon: 'facebook' },
    { name: 'twitter', icon: 'twitter-x' },
    { name: 'pinterest', icon: 'pinterest' },
    { name: 'instagram', icon: 'instagram' }
  ];

  //Blogs 
  blogItems = [
    {
      image: 'assets/images/blogs/blog-md-1.jpg',
      alt: '01',
      category: 'Branding',
      title: "It's Like Dating Entertainment",
      date: 'Apr 29, 2025',
      link: '/blog-grid', 
    },
    {
      image: 'assets/images/blogs/blog-md-2.jpg',
      alt: '02',
      category: 'Design',
      title: 'Out of The Ruins',
      date: 'Apr 28, 2025',
      link: '/blog-grid',
    },
    {
      image: 'assets/images/blogs/blog-md-3.jpg',
      alt: '03',
      category: 'Marketing',
      title: 'Woman Lifestyle',
      date: 'Apr 27, 2025',
      link: '/blog-grid',
    },
    {
      image: 'assets/images/blogs/blog-md-4.jpg',
      alt: '04',
      category: 'Education',
      title: 'Photography Techniques',
      date: 'Apr 27, 2025',
      link: '/blog-grid',
    },
  ];

  //Blogs
  blogs = [
    {
      date: '04',
      month: 'April',
      title: 'Clean Code, Bold Design',
      description:'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
      image: 'assets/images/blogs/blog-wide-1.jpg',
      link: '/blog-grid'
    },
    {
      date: '03',
      month: 'May',
      title: 'Web Templates That Sell',
      description:'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
      image: 'assets/images/blogs/blog-wide-2.jpg',
      link: '/blog-grid'
    },
    {
      date: '02',
      month: 'June',
      title: 'Bootstrap Templates Pack',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
      image: 'assets/images/blogs/blog-wide-3.jpg',
      link: '/blog-grid'
    }
  ];

}
